export default "__VITE_ASSET__3f725ae4__"